import { useMemo, useState, type ChangeEvent } from "react";

import { type SearchFieldProps } from "ui/search-field/search-field.types";

import { debounce } from "helpers/debounce";

export const SEARCH_DEBOUNCE_MS = 300;

export const useSearchField = ({ onChange }: Pick<SearchFieldProps, "onChange">) => {
  const [value, setValue] = useState("");

  const debouncedChange = useMemo(() => debounce(onChange, SEARCH_DEBOUNCE_MS), [onChange]);

  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setValue(event.target.value);
    debouncedChange(event.target.value.trim());
  };

  const handleClear = () => {
    setValue("");
    onChange("");
    debouncedChange("");
  };

  return { value, handleChange, handleClear };
};
